import type { Middleware } from '@arcubase/client-ts'
import { useUserStore } from '@/store/user'
import { logout, refreshSession } from '@/auth/sessionRuntime'

// 业务错误处理中间件
export const businessErrorMiddleware: Middleware = async (context, next) => {
  const result = await next()
  
  // === RESPONSE 阶段 (next() 之后) ===
  const { response } = context
  
  // 检查业务错误
  if (response?.data?.error) {
    const error = response.data.error
    
    if (error.key === 'auth.authorization_required') {
      console.log('[businessErrorMiddleware] auth.authorization_required detected!');
      console.log('[businessErrorMiddleware] Request:', context.config.method, context.config.url);
      console.log('[businessErrorMiddleware] Request headers:', context.config.headers);
      console.log('[businessErrorMiddleware] Response:', response.data);

      if (!context.config._slauthRetried) {
        context.config._slauthRetried = true
        try {
          const session = await refreshSession()
          if (session?.access_token) {
            return await next()
          }
        } catch (refreshError) {
          console.warn('[businessErrorMiddleware] slauth refresh failed', refreshError)
        }
      }
      
      await logout()
      window.location.reload()
      return result // 返回结果但不继续处理
    }
    
    if (error.key === 'auth.user_not_active') {
      const store = useUserStore()
      ;(store as any).clearTenant()
      window.location.pathname = '/'
      return result
    }
  }
  
  // 检查 HTTP 状态码
  if (response?.status && response.status !== 200) {
    throw new Error('network error...')
  }
  
  return result
}
